import type { OrderCompensationType } from '../enums/OrderCompensationType'

export class CompensationFilterEntity {
  id!: string
  type?: OrderCompensationType
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
